import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  questionGroup: css`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: 360px) {
      gap: 6px;
    }
  `,
  answerGroup: css`
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;

    @media (max-width: 480px) {
      gap: 12px;
    }

    @media (max-width: 360px) {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }
  `,
  yesNoButtons: css`
    display: flex;
    gap: 8px;

    @media (max-width: 360px) {
      width: 100%;
      gap: 6px;
    }
  `,
  yesNoButton: ({ theme }) => css`
    height: 26px;
    padding: 4px 9px 4px 4px;
    gap: 6px;
    border-radius: 12px;
    color: ${theme.colors.neutral.variant[70]};

    @media (max-width: 360px) {
      flex: 1;
      justify-content: center;
      height: 28px;
      gap: 4px;
      padding: 4px 8px;
    }
  `,
  suggestionsList: ({ theme }) => css`
    margin: 0;
    padding-left: 22px;
    li {
      color: ${theme.colors.neutral.variant[60]};
      font-size: 10px;

      @media (max-width: 360px) {
        font-size: 9px;
      }
    }
  `,
} satisfies Styles<void>;

export const useYesNoQuestionStyles = withStyles(styles);
